import React from "react";

const Prices = () => {
    return (
        <div className={"about-tajine-container component"}>
            <div className={"contentContainer"}>
            <div className={"about-tajine-box price1"}>
                <h2>Tajine</h2>
                <p> A tajine különleges formájú mázas cserép párolóedény. Eredete Észak-Afrika, főként Marokkóban használják. A benne elkészített ételnek is tajine a neve. Formai jellegzetességei: lapos tálszerű alj, amelyre egy magas kúpos tető illeszkedik. Ebben az aránylag magas tetőben feldúsult gőz párolja omlósra a benne készült ételt. Marokkóban az utcán faszénparázstartón izzó faszénen készítik ma is a "street food"-ot a tajin-et.</p>
            </div>
            <div className={"about-tajine-box price2"}>
                <p>Az étel elkészítésére alkalmas nagyobb méretű főző tajine lángálló agyagból készül. Funkciója a lassú főzés. A kisebb általában egyszemélyes, díszesebb tálaló tajine csak az étel tálalására szolgál.
                A tajine edény használható faszénparázson (tradícionális ételkészítés), kemencében, gáz- és villanysütőben és gáztűzhelyen is.
                Az egyedi készítésű tajine edények megjelenése (díszítettség, színvilág) a megrendelő fantáziáját tükrözi és harmonizál a vásárló stílusával, tökéletesen illesztkedve a konyhai méretekhez.</p>
           </div>
        </div>
        </div>
    );
};

export default Prices;